import './App.css';
import React, {useEffect} from 'react';
import {BrowserRouter} from 'react-router-dom';
import './assets/css/tailwind.css'
import './assets/libs/@mdi/font/css/materialdesignicons.min.css'
import './assets/libs/@iconscout/unicons/css/line.css'
import './assets/libs/tobii/css/tobii.min.css'
import './assets/images/favicon.ico'
import Switcher from './component/Switcher';
import ScrollToTop from './component/Scroll-top';
import {ToastContainer} from "react-toastify";
import {HelmetProvider} from "react-helmet-async";
import Routers from "./Routers";


export default function App() {

    useEffect(() => {
        document.documentElement.setAttribute("dir", "ltr");
        document.documentElement.classList.add('light');
    }, []);

    return (
        <BrowserRouter>
            <HelmetProvider>
                <ScrollToTop/>
                <ToastContainer position="top-right" autoClose={5000}/>
                <Routers/>
                <Switcher/>
            </HelmetProvider>
        </BrowserRouter>
    )
};